export enum PlayTypeEnum{
  SUPER_PALE = 0,
  QUINIELA = 1,
  PALE = 2,
  TRIPLETA = 3
}

export enum RaffleStatus{
  Pending = 0,
  Open = 1,
  Close = 2
}
